module.exports = __webpack_public_path__ + "fonts/DroidSans-Bold.22ef71e.woff2";